import React from "react";

/**
 * Componente para mostrar y gestionar el input de archivo en la evaluación de objetivos.
 * Permite visualizar el archivo actual, descargarlo y cambiarlo si está en modo edición.
 */
const FileInput = ({
    value,       // Valor actual del archivo (string o File)
    onChange = () => {},    // Handler para cambio de archivo opcional
    isEditing,   // Indica si está en modo edición
    inputProps = {}, // Props adicionales para el input
}) => {
    // Determina si el archivo es una ruta válida (string) o un objeto File
    const isStringFile =
        typeof value === "string" && value.includes("Evaluacion_objetivos_archivos_cumplimiento/");
    // Obtiene el nombre del archivo para mostrar
    const fileName =
        typeof value === "string"
            ? value.split("/").pop()
            : value?.name;

    // Prefijo de la URL para archivos almacenados en el servidor
    const urlPrefix = process.env.REACT_APP_URL + "/media/";

    return (
        <div className="mt-2">
            {value ? (
                <div>
                    {/* Enlace para descargar o visualizar el archivo */}
                    <a
                        href={typeof value === "string" ? `${urlPrefix}${value}` : "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                        tabIndex={isStringFile ? 0 : -1}
                        style={
                            isStringFile
                                ? {}
                                : { pointerEvents: "none", color: "#aaa", textDecoration: "none" }
                        }
                        aria-disabled={!isStringFile}
                    >
                        {fileName}
                    </a>
                    <br />
                    {/* Botón para cambiar el archivo si está en modo edición y el archivo es válido */}
                    {isEditing && isStringFile && (
                        <label className="btn btn-link p-0">
                            <span className="material-icons">attach_file</span> Cambiar archivo
                            <input
                                type="file"
                                style={{ display: "none" }}
                                onChange={onChange}
                                disabled={!isEditing}
                                {...inputProps}
                            />
                        </label>
                    )}
                </div>
            ) : (
                // Input para subir archivo si no hay ninguno cargado
                <input
                    type="file"
                    onChange={onChange}
                    disabled={!isEditing}
                    {...inputProps}
                />
            )}
        </div>
    );
};

export default FileInput;